<template>
  <div>
    <div class="d-flex flex-row justify-space-between align-center mb-3">
      <h1 class="section-header__title mb-0">
        Карточка организации
      </h1>
    </div>
    <WrapperCollapse
        title="Результаты открытого публичного конкурса по распределению контрольных цифр приема за счет бюджетных ассигнований федерального бюджета на 2024/25 учебный год"
        :initialOpen="true"
        v-if="currentStage===8"
    >
      <ContainerKCPInformationDocuments :status-org="getBlockInfoOrganization"/>
    </WrapperCollapse>
    <wrapper-collapse
      title="Информация об организации"
      initial-open
      custom-class="main-org pa-0"
    >
      <template #title>
        <div class="collapse__title">Информация об организации
          <v-icon size="20" color="white" :theme="`${icon.color}`" class="status__icon">{{ icon.name }}</v-icon>
        </div>
      </template>
      <org-main-container :appealStatus="appeal" @update-appeal="updateMainAppeal($event)"/>
    </wrapper-collapse>
    <wrapper-collapse
      title="Информация о структурных подразделениях/филиалах"
      initial-open
      custom-class="filals-orgs pa-0"
    >
      <org-filials-container/>
    </wrapper-collapse>
    <wrapper-collapse
      title="Уставные документы"
      initial-open
    >
      <file-container :files-config="filesConfig"/>
    </wrapper-collapse>
    <wrapper-collapse
      title="Сведения о руководителе образовательной организации"
      initial-open
      custom-class="main-org pa-0"
    >
      <contact-director/>
    </wrapper-collapse>
    <wrapper-collapse
      title="Контактная информация представителя организации, ответственного за участие в конкурсе"
      initial-open
      custom-class="main-org pa-0"
    >
      <contact-main/>
    </wrapper-collapse>
  </div>
</template>

<script>
import WrapperCollapse from "@/components/wrappers/WrapperCollapse";
import OrgMainContainer from "@/containers/OrgMainContainer";
import OrgFilialsContainer from "@/containers/OrgFilials/OrgFilialsContainer";
import FileContainer from "@/containers/FileContainer";
import ContactDirector from "@/containers/ContactDirector";
import ContactMain from "@/containers/ContactMain";
import {mapActions, mapGetters} from "vuex";
import ContainerKCPInformationDocuments from "@/containers/ContainerKCPInformationDocuments.vue";

export default {
  name: "ContactsOrganization",
  components: {
    ContainerKCPInformationDocuments,
    ContactMain, ContactDirector, FileContainer, OrgFilialsContainer, OrgMainContainer, WrapperCollapse},
  data() {
    return {
      filesConfig: [
        {
          name: 'Устав образовательной организации',
          types: ['application/pdf'],
          typesForChose: ['application/pdf'],
          id: null,
          fileType: 'USTAV_MAIN_ORG'
        },
        {
          name: 'Приказ учредителя о назначении руководителя образовательной организации',
          types: ['application/pdf'],
          typesForChose: ['application/pdf'],
          id: null,
          fileType: 'PRIKAZ_MAIN_ORG'
        },
      ],
      appeal: undefined
    }
  },
  computed: {
    ...mapGetters('checkFilled', {currentStage: 'currentStage',getBlockInfoOrganization: 'getBlockInfoOrganization',}),
    icon() {
      switch (this.appeal) {
        case null:
          return {name: 'mdi-check', color: 'warning'}
        case false:
          return {name: 'mdi-close', color: 'error'}
        default:
          return {name: 'mdi-check', color: 'success'}
      }
    }
  },
  created() {
    this.getAllOrganizationAppeals();
  },
  methods: {
    ...mapActions('appeals', {
      getAllOrganizationAppeals: 'getAllOrganizationAppeals'
    }),
    /**
     * @param {boolean | null} hasAppeal
     * */
    updateMainAppeal(hasAppeal = null) {
      this.appeal = hasAppeal;
    }
  },
}
</script>

<style scoped>

</style>